import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@/services/auth-service';

const HomePage = () => {
    const user = useUser();
    const navigate = useNavigate();

    useEffect(() => {
        if (user?.email) {
            navigate('/library');
        } else {
            navigate('/');
        }
    }, [user, navigate]);

    // Return null since this is just a routing component
    return null;
};

export default HomePage;
